import { useEffect, useState } from 'react'

import { useGoogleAnalytics } from '@services/hooks/useGoogleAnalytics'

export const GoogleAnalyticsProvider = ({ children, initialData }) => {
    const { initializeGA } = useGoogleAnalytics()
    const [isInitializing, setIsInitializing] = useState(true)

    useEffect(() => {
        const loadGA = async () => {
            try {
                await initializeGA(initialData)
                setIsInitializing(false)
            } catch (err) {
                setIsInitializing(false)
            }
        }

        loadGA()
    }, [initializeGA, initialData])

    if (isInitializing) return <></>

    return <>{children}</>
}